<template>
    <section class="video-fullscreen">
        <div class="video grayscale" data-overlay-dark="1">
            <div class="desgradado"></div>
        <video playsinline autoplay loop muted aria-label="Background Video">
            <source :src="aboutVideoBanner" type="video/mp4">
            <!-- Fallback for unsupported formats -->
            Your browser does not support HTML5 video.
        </video>
        
        </div>
        <div class="v-middle">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12 mt-60">
                        <h4 class="hZUCZe">{{ $t('JLHSOFT TECHNOLOGY') }}</h4>
                        <h1 class="mb-10 text-h2-sans">{{ $t('Innovation and') }}<br>{{ $t('Technological Future') }}</h1>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="container">
                        <hr>
                        <h4 class="hZUCZe fs-25px">{{ $t('Dynamic and Innovative Digital Agency') }}</h4>
                        <h2 class="mb-10 text-h2-sans">{{ $t('Who We Are?') }}</h2>
                        <p class="text-p-sans mt-60">{{ $t('We are a dynamic and innovative company with more than 10 years of experience in the market, dedicated to offering technological solutions and digital marketing strategies that drive business growth.') }}</p>
                        <p class="text-p-sans">{{ $t('We specialize in developing custom systems, software, websites, mobile applications and cloud solutions designed to optimize processes, increase productivity and guarantee a high return on investment.') }}</p>
                        <p class="text-p-sans">{{ $t('Additionally, we offer complete digital marketing strategies to maximize the visibility of your business online. From SEO and social media advertising to email marketing campaigns, we connect your brand with the right audience and generate measurable results.') }}</p>
                        <p class="text-p-sans">{{ $t('At JLHSOFT TECHNOLOGY, we design solutions adapted to the unique needs of each organization. Whether you need to modernize your systems, automate processes or manage data efficiently, we are here to help you achieve your goals.') }}</p>
                        <p class="text-p-sans">{{ $t('Committed to innovation and excellence, we help businesses thrive in the digital age. Trust us to boost your online presence, engage your audience and ensure a reliable and efficient service.') }}</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="item">
                        <div class="wrap">
                          <div class="video-jlhsoft">
                            <video playsinline autoplay muted loop>
                              <source :src="videoMp4" type="video/mp4">
                              <!-- Fallback for unsupported formats -->
                              Your browser does not support HTML5 video.
                            </video>
                          </div>
                            
                        </div>
                    </div>
              </div>
                
            </div>
        </div>
    </section>
    <section>
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="sr-border">
              <img class="img-v" :src="vision"><br>
              <h4 class="mb-8 hZUCZe">{{ $t('Mission') }}</h4><br>
              <p class="mt-6-until-sm mt-3 mb-0">{{ $t('Our mission at JLHSOFT TECHNOLOGY is to empower businesses of all sizes to thrive in the digital environment by providing tailored marketing strategies, user-centric web development, and reliable hosting services. We seek to exceed expectations, foster growth and cultivate lasting relationships with our clients.') }}</p>
          </div>
          </div>
          <div class="col-md-4">
            <div class="sr-border">
              <img class="img-v" :src="mision"><br>
              <h4 class="mb-8 hZUCZe">{{ $t('Vision') }}</h4><br>
              <p class="mt-6-until-sm mt-3 mb-0">{{ $t('Our vision is to be the leading force in transforming the digital experience for companies around the world. We envision a future where every brand has access to innovative digital solutions that elevate their online presence and drive sustainable growth.') }}</p>
          </div>
          </div>
          <div class="col-md-4">
            <div class="sr-border">
              <img class="img-v" :src="valores"><br>
              <h4 class="mb-8 hZUCZe">{{ $t('Our Process') }}</h4><br>
              <p class="mt-6-until-sm mt-3 mb-0">{{ $t('We follow a simple and effective process to deliver high-quality solutions to our clients. From initial project planning and conceptualization to final implementation and delivery, we strive to create a seamless and enjoyable experience for our clients.') }}</p>
          </div>
          </div>
        </div>
    </div>
    </section>
</template>

<script>
import aboutVideoBanner from '@/assets/videos/about_video_banner.mp4'
import videoMp4 from '@/assets/videos/55620776.mp4'
import vision from '@/assets/images/vision.webp'
import mision from '@/assets/images/mision.webp'
import valores from '@/assets/images/valores.webp'  
export default {
    name: 'AboutPage',
    
    data() {
        return {
            aboutVideoBanner,
            videoMp4,
            vision,
            mision,
            valores
        };
    },
}
</script>

<style scoped>
.video-fullscreen {
    overflow: hidden;
  }
  .video-fullscreen .video.grayscale {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
  }
.video-fullscreen .video {
    height: 100vh;
}
.video-fullscreen video {
    width: 100vw;
    min-width: 100%;
    height: 100vh;
    -o-object-fit: cover;
    object-fit:cover;
}

.v-middle {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    -webkit-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    z-index: 9;
}
  
.video-jlhsoft {
  position: relative;
  width: 100%; /* Asegura que ocupe todo el ancho de la columna */
  padding-top: 56.25%; /* 16:9 aspect ratio */
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

.video-jlhsoft video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Mantén el video dentro del contenedor y ajustado */
}

.img-v{
    width: 60px;
    height: 60px;
    float: left;
    display: block;
    margin-right: 10px;
}

@media (max-width: 768px) {
  
    .d-none-sm{
      display: none;
    }

}
</style>